document.addEventListener('DOMContentLoaded', function() {

  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function toggleSerialValidationError(show){
    if (!searchError) return;
    if (show) searchError.classList.remove('hidden');
    else searchError.classList.add('hidden');
  }

  function isSerialValid(value) {
    if (value.length !== 10) return false;

    const today = new Date();
    const currentYear = Number(String(today.getFullYear()).slice(-2));

    const serialYear = Number(value.slice(0, 2));
    const serialMonth = Number(value.slice(2, 4));

    if (serialYear > currentYear) return false;
    if (serialMonth < 1 || serialMonth > 12) return false;

    return true;
  }

  // This callback is triggered when a variant change PUB_SUB event is triggered
  function onVariantChange({data}){
    const {variant} = data;
    const variantId = variant.id;
    const variantTitle = variant.title;
    // We check if Model has changed, in this way we are able to skip a fetch and a re-render
    const selectedModelOnVariantChange = variantTitle.split(' / ')[0].trim();
    const previousModelSelection = viewsWrapper.getAttribute('data-active-model').trim();
    let isModelChanged = selectedModelOnVariantChange !== previousModelSelection;

    if (!variantId) return;
    // Update the model selector
    if (modelOptions && modelOptions.length > 0){
      modelOptions.forEach((option) => {
        const optionVariantId = option.dataset.variantId;
        if (optionVariantId === variantId.toString()) {
          option.classList.add('selected');
          modelSelectorLabel.childNodes[0].textContent = option.textContent.trim();
        }
        else option.classList.remove('selected');
      });
    }

    if(isModelChanged) {
      viewsWrapper.setAttribute('data-active-model', selectedModelOnVariantChange);
      fetchVariantsMarkup(variantId);
    }
  }
  // When user select a model from the section selector
  function onModelSelection(){
    const variantId = this.dataset.variantId;
    const selectedModel = this.dataset.optionName.trim();

    modelOptions.forEach((opt) => opt.classList.remove('selected'));
    this.classList.add('selected');
    modelSelectorLabel.childNodes[0].textContent = selectedModel;

    if (modelSelectorButton) toggleAccordion(modelSelectorButton);

    fetchVariantsMarkup(variantId,selectedModel);
  }
  function fetchVariantsMarkup(variantId,selectedModel){
    loadingSpinner.classList.remove('hidden');
    if(errorElement) errorElement.classList.add('hidden');

    fetch(
      `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`,
    )
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.text();
      })
      .then((data) => {
        const html = parser.parseFromString(data, 'text/html');
        viewsWrapper.setAttribute('data-active-model', selectedModel);
        renderMarkup(html);
      })
      .catch((error) => {
        viewsWrapper.setAttribute('data-active-model', 'none');
        selectors.forEach(selector => {
          const parent = document.getElementById(selector);
          if (parent) parent.classList.add('hidden');
        });
        if (errorElement) errorElement.classList.remove('hidden');
        console.error('Fetching: section-spare-parts: ', error);
      })
      .finally(() => {
        loadingSpinner.classList.add('hidden');
      })
  }
  function renderMarkup(html){
    const filterStr = document.querySelector('.search-input').value.trim().toUpperCase();
    const isValid = isSerialValid(filterStr);
    // Only once for selection, compute the validity range
    // If there are no filters, we skip filtering
    // const serialUnix = isValid ? computeSerialRange(filterStr) : null;

    // By default, we filter with end of current month
    const serialUnix = isValid
      ? computeSerialRange(filterStr)
      : computeSerialRange();


    selectors.forEach(selector => {
      const oldElement = document.getElementById(selector);
      const newElement = html.querySelector(`#${selector}`);

      if (serialUnix){
        const entries = newElement.querySelectorAll('.js_view-entry');
        if (entries) filterResultsBySerial(entries,serialUnix,newElement);
      }

      if (oldElement && newElement) oldElement.replaceWith(newElement);
      if (selector === 'SparePartsExploded' || selector === 'SparePartsFlow') {
        sortByPosition(document.getElementById(selector));
      }

      initIframeOverlays();
    })
  }

  function sortByPosition(parent) {
    const list = parent.querySelector('.spare-parts-list');
    if (!list) return;
    const entries = [...list.querySelectorAll('.js_view-entry')];
    entries.sort((a, b) => {
      const pa = a.dataset.position || '';
      const pb = b.dataset.position || '';
      return pa.localeCompare(pb, undefined, { numeric: true });
    });
    entries.forEach(entry => list.appendChild(entry));
  }

  function computeSerialRange(filterStr = undefined){
    let serial = filterStr;
    const today = new Date();
    // When there is no filter, we use today as default filter value
    // We are skipping this case, when there is no filter, we render what we get from server
    // All SpareParts, only the most recent Views
    if (!serial) {
      const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
      const currentYear = String(today.getFullYear()).slice(-2);
      serial = `${currentYear}${currentMonth}****`;
    }

    const serialFirst4 = serial.slice(0, 4);
    const serialYearSuffix = serialFirst4.slice(0, 2);
    const serialMonth = serialFirst4.slice(2, 4);
    const serialYear = '20' + serialYearSuffix;
    const serialDate = new Date(Number(serialYear), Number(serialMonth), 0);
    return Math.floor(serialDate.getTime() / 1000);
  }
  function onSerialUpdate(event){
    const value = event.target.value.trim();
    const isEmpty = value.length === 0;
    const isValid = isSerialValid(value);
    toggleSerialValidationError(!isValid && !isEmpty);
    // const serialUnix = isValid ? computeSerialRange(value) : null;
    const serialUnix = isValid
      ? computeSerialRange(value)
      : computeSerialRange();
    // if (!isValid) {
    //   resetFilter();
    //   return;
    // }

    // Almost same logic of renderMarkup(), but in this case we update the DOM without replaceWith()
    selectors.forEach(selector => {
      const parent = document.getElementById(selector);
      if (!parent) return;
      const entries = parent.querySelectorAll('.js_view-entry');
      if (entries && entries.length > 0) filterResultsBySerial(entries,serialUnix,parent);
    })
  }
  // Update classes, to show or hide results.
  // When there are validity ranges that overlaps, we use hasVisible to render only the first occurrence
  // We show all the results when we are looping throw #SpareParts
  function filterResultsBySerial(entries,serialUnix,parent){
    let visibleCount = 0;
    let hasVisible = false;
    const isSpareParts = parent.id === 'SparePartsExploded' || parent.id === 'SparePartsFlow';

    entries.forEach(entry => {
      const start = toUnixSeconds(entry.dataset.start);
      const end = toUnixSeconds(entry.dataset.end);
      const isValid = serialUnix >= start && serialUnix <= end;
      if (isSpareParts){
        if (isValid) visibleCount++;
        entry.classList.toggle('hidden', !isValid);
      }
      else {
        // We show only one image, after that we already found it, we hide all the others
        if (isValid && !hasVisible) {
          entry.classList.remove('hidden');
          visibleCount++;
          hasVisible = true;
        } else {
          entry.classList.add('hidden');
        }
      }
    })

    // Show or hide No results string
    if (!visibleCount) {
      const emptyWrapper = parent.querySelector('.js_empty-view');
      if (emptyWrapper) emptyWrapper.classList.remove('hidden');
    }
    else {
      const emptyWrapper = parent.querySelector('.js_empty-view');
      if (emptyWrapper) emptyWrapper.classList.add('hidden');
    }
  }

  function resetFilter(){
    selectors.forEach(selector => {
      const parent = document.getElementById(selector);
      if (!parent) return;

      const entries = parent.querySelectorAll('.js_view-entry');
      const emptyWrapper = parent.querySelector('.js_empty-view');

      if (selector === 'SparePartsExploded' || selector === 'SparePartsFlow') entries.forEach(entry => entry.classList.remove('hidden'));
      else {
        entries.forEach(((entry,i) => {
          if (i === 0) entry.classList.remove('hidden');
          else entry.classList.add('hidden');
        }))
      }
      if (emptyWrapper) emptyWrapper.classList.add('hidden');
    })
  }

  // With css rules, we show Exploded views image, or Flow Views image
  function onViewToggle(){
    const selectedView = this.dataset.viewType;
    viewsTogglers.forEach(toggle => toggle.classList.remove('active'));
    this.classList.add('active');
    viewsWrapper.setAttribute('data-active-view', selectedView);

    const activeEntries = viewsWrapper.querySelectorAll(`.${selectedView}-entry:not(.hidden) iframe`);
    activeEntries.forEach(iframe => {
      if (iframe.dataset.src) iframe.src = iframe.dataset.src;
    });

    const inactiveView = selectedView === 'exploded' ? 'flow' : 'exploded';
    viewsWrapper.querySelectorAll(`.${inactiveView}-entry iframe`).forEach(iframe => {
      iframe.dataset.src = iframe.src;
      iframe.removeAttribute('src');
    });
  }

  function initLazyIframes() {
    const activeView = viewsWrapper.getAttribute('data-active-view');
    const inactiveView = activeView === 'exploded' ? 'flow' : 'exploded';
    document.querySelectorAll(`.${inactiveView}-entry iframe`).forEach(iframe => {
      iframe.dataset.src = iframe.getAttribute('src');
      iframe.removeAttribute('src');
    });
  }

  function toUnixSeconds (dateStr) {
    return Math.floor(new Date(dateStr).getTime() / 1000);
  }

  function initIframeOverlays() {
    document.querySelectorAll('.js_iframe-overlay').forEach(overlay => {
      overlay.addEventListener('click', onIframeOverlayClick);
    });
  }

  function onIframeOverlayClick() {
    const wrapper = this.closest('.js_view-entry');
    const iframeUrl = wrapper?.dataset.iframeUrl;
    if (!iframeUrl) return;

    const modal = document.getElementById(`SparePartsIframeModal-${sectionId}`);
    const modalContent = modal?.querySelector('.js_spare-parts-modal-content');
    if (!modal || !modalContent) return;

    modalContent.innerHTML = `
      <iframe
       src="${iframeUrl}" 
       style="border:none;width:100%;height:100%;position: absolute;top: 0;left: 0;"
       tabindex="-1"
       ></iframe>`;
    modal.show(this);
  }

  // We register a callback when user select a variant from <product-info>
  subscribe(PUB_SUB_EVENTS.variantChange,onVariantChange);

  const modelOptions = document.querySelectorAll('.js_model-variant-option');
  const modelSelectorLabel = document.getElementById('variant-label-button');
  const modelSelectorButton = document.getElementById('variant-label-button');

  const viewsTogglers = document.querySelectorAll('.js_view-toggler');
  const viewsWrapper = document.querySelector('div[data-active-view]');

  const parser = new DOMParser();
  const searchInput = document.querySelector('.js_search-input');
  const searchError = document.querySelector('.js_search-error');
  const sectionId = document.querySelector('.js_spare-parts-viewer').dataset.id;
  const loadingSpinner = document.querySelector('.js_section-spare-parts-loader');
  const errorElement = document.querySelector('.js_section-spare-parts-error');

  const selectors = [
    'ExplodedViews',
    'FlowViews',
    'SparePartsExploded',
    'SparePartsFlow',
  ];

  if (modelOptions && modelOptions.length > 0) {
    modelOptions.forEach(option => option.addEventListener('click',onModelSelection));
  }
  const debouncedSerialUpdate = debounce(onSerialUpdate, 350);
  // Allow right click -> paste
  searchInput.addEventListener('paste', (event) => {
    event.preventDefault();
    const pasted = (event.clipboardData || window.clipboardData).getData(
      'text',
    );
    const onlyDigits = pasted.replace(/\D/g, '').slice(0, 10);
    event.target.value = onlyDigits;
    event.target.dispatchEvent(new Event('input'));
  });
  // Only numbers
  searchInput.addEventListener('keydown', (event) => {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Enter',
    ];
    if (allowedKeys.includes(event.key)) return;
    if (event.metaKey || event.ctrlKey) return;
    if (!/^\d$/.test(event.key)) event.preventDefault();
  });
  searchInput.addEventListener('input', (event) => {
    const sanitized = event.target.value.replace(/\D/g, '').slice(0, 10);
    if (event.target.value !== sanitized) {
      event.target.value = sanitized;
    }
    debouncedSerialUpdate(event);
  });
  viewsTogglers.forEach(toggler => toggler.addEventListener('click',onViewToggle));

  ['SparePartsExploded', 'SparePartsFlow'].forEach(id => {
    const el = document.getElementById(id);
    if (el) sortByPosition(el);
  });

  // const serialUnix = computeSerialRange();
  //
  // selectors.forEach(selector => {
  //   const parent = document.getElementById(selector);
  //   if (!parent) return;
  //
  //   const entries = parent.querySelectorAll('.js_view-entry');
  //   if (entries && entries.length > 1) {
  //     filterResultsBySerial(entries, serialUnix, parent);
  //   }
  // });

  initLazyIframes();
  initIframeOverlays();
});